import React from 'react';
import { FormikProps } from 'formik';
import { LIST_TYPES } from 'Common/enums';
import { GeneralForm, PanForm } from '../../ListTypeForms';
import RangeForm from '../../ListTypeForms/RangeForm';

type Props = {
    listType: SingleListType;
    merchantSpecific: boolean;
    error: any;
    formikProps: FormikProps<any>;
};

const FormBody = ({ listType, merchantSpecific, error, formikProps }: Props) => {
    switch (listType) {
        case LIST_TYPES.GENERAL:
            return <GeneralForm merchantSpecific={merchantSpecific} error={error} formikProps={formikProps} />;
        case LIST_TYPES.PAN:
            return <PanForm merchantSpecific={merchantSpecific} error={error} formikProps={formikProps} />;
        case LIST_TYPES.RANGE:
            return <RangeForm merchantSpecific={merchantSpecific} error={error} formikProps={formikProps} />;
        default:
            return <div>No form available for this list type</div>;
    }
};

export default FormBody;
